import { createTheme, CSSVariablesResolver, MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import React from 'react';

import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';

const theme = createTheme({});

const cssVarResolver: CSSVariablesResolver = () => ({
  variables: {},
  light: {
    '--mantine-color-text': '#364053',
  },
  dark: {
    '--mantine-color-text': '#FFFFFF',
  },
});

const MantineTheme: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <MantineProvider theme={theme} defaultColorScheme="light" cssVariablesResolver={cssVarResolver}>
      <ModalsProvider>
        <Notifications position="bottom-right" autoClose={2000} zIndex={5010} />
        {children}
      </ModalsProvider>
    </MantineProvider>
  );
};

export default MantineTheme;
